import { match, P } from 'ts-pattern';
import { TimePoint, TimePointType } from '../../../api/timeranges/types';
import { Languages } from '../../../constants';
import {
  formatFinQuarter,
  formatFinYear,
  formatMonth,
  formatYear,
} from '../../../date/date-utils';
import { Granularity } from './types';
import { getTimePointTypeForNewGranularity } from './utils';

export const dateFormatter = (
  date: TimePointType,
  granularity: Granularity,
  locale: Languages
): string => {
  return match({ granularity, date })
    .with({ granularity: Granularity.MONTH, date: P.instanceOf(Date) }, (v) =>
      formatMonth(v.date, locale)
    )
    .with({ granularity: Granularity.YEAR, date: P.number }, (v) =>
      formatYear(v.date, locale)
    )
    .with(
      {
        granularity: Granularity.FINQUARTER,
        date: { year: P.number, quarterOfYear: P.number },
      },
      (v) => formatFinQuarter(v.date, locale)
    )
    .with({ granularity: Granularity.FINYEAR, date: P.number }, (v) =>
      formatFinYear(v.date, locale)
    )
    .otherwise(() => {
      throw new Error(
        `Unsupported granularity and date data type ${granularity}, ${typeof date}`
      );
    });
};

export const displayDateRange = (
  start: TimePointType,
  end: TimePointType,
  granularity: Granularity,
  locale: Languages,
  timePoints: TimePoint[]
) => {
  const startMonth = getTimePointTypeForNewGranularity(
    start,
    granularity,
    Granularity.MONTH,
    timePoints,
    'start'
  ) as Date;
  const endMonth = getTimePointTypeForNewGranularity(
    end,
    granularity,
    Granularity.MONTH,
    timePoints,
    'end'
  ) as Date;
  return `${dateFormatter(startMonth, Granularity.MONTH, locale)} - ${dateFormatter(endMonth, Granularity.MONTH, locale)}`;
};

export const displayDate = (
  date: TimePointType,
  granularity: Granularity,
  locale: Languages
) => {
  return `${dateFormatter(date, granularity, locale)}`;
};
